import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Offcanvas from "react-bootstrap/Offcanvas";

import Card from "react-bootstrap/Card";
import ModalSave from "../../../common/ModalSave";
import Validation from "../../../common/FormValidation";
import { CancelButton, SaveButton } from "../../../common/Button";

import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";
import { TicketStatus } from "../../../../utils/apis/masters/masters";
import Select from "react-select";
import { IDS, Select2Data } from "../../../../utils/common";
library.add(fas);

const EditOffCanvance = (props) => {
  const { postData, getData, IMG_URL } = useContext(Context);

  const id = props.show;

  const [formData, setFormData] = useState({
    name: "",
  });

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const handleChange = (e) => {
    if (e?.name == "ticket_status_id") {
      setFormData({ ...formData, [e.name]: e });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = Validation.FormValidation({
      classname: ".ticketsclass",
    });

    const validationErrorsSelect = Validation.SelectValidation({
      classname: ".ticketsclass",
    });

    // console.log(formData && validationErrorsSelect);
    // return;
    if (validationErrors && validationErrorsSelect) {
      try {
        const response = await postData(
          `/ticket-management/tickets/${id}`,
          formData,
        );

        if (response.success) {
          setShowModal({ code: response.code, message: response.message });
          setTimeout(() => {
            setShowModal(0);
            props.handleClose();
          }, 1000);
        } else {
          setShowModal({ code: response.code, message: response.message });
          setTimeout(() => {
            setShowModal(0);
            props.handleClose();
          }, 1000);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    }
  };

  const GetEditData = async () => {
    const response = await getData(`/ticket-management/tickets/${id}`);
    // if (
    // IDS.TicketStatus.Requested === response?.data?.ticket_status_id ||
    //   IDS.TicketStatus.Processing === response?.data?.ticket_status_id;
    // ) {
    //   setFormData({ ...response?.data, ticket_status_id: null });
    // } else {
    setFormData({
      ...response?.data,
      ticket_status_id: {
        value: response?.data?.ticket_status_id,
        label: response?.data?.ticket_status?.name || "",
        name: "ticket_status_id",
      },
    });
    // }
  };

  const [ticket_status, setTicketStatus] = useState([]);

  const getMastersData = async () => {
    {
      const res = await TicketStatus();
      await setTicketStatus(await Select2Data(res?.data, "ticket_status_id"));
    }
  };

  useEffect(() => {
    GetEditData();
    getMastersData();
  }, []);

  const errorStyle = {
    color: "red",
    marginLeft: "5px",
  };

  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%" }}
        placement={"end"}
        onHide={props.handleClose}
      >
        <Offcanvas.Header closeButton>
          {/* <Offcanvas.Title>Edit Tickets</Offcanvas.Title> */}
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Card className="shadow-lg p-3 mb-5 bg-white rounded">
            <Card.Body>
              <Card.Title>Edit Tickets</Card.Title>
              <hr />
              <Container>
                <Row>
                  <Col md={12}>
                    <Container>
                      <Row className="">
                        <Col xxl={12} xl={12} md={10}>
                          <Form
                            onSubmit={handleSubmit}
                            role="form"
                            className="ticketsclass ticketStatusclass"
                          >
                            <Row>
                              <Col
                                lg={8}
                                md={10}
                                className=" mx-auto Add-content"
                              >
                                <Row>
                                  <Col md={6}>
                                    <div className="main-form-section mt-5">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={3}>
                                          Tickets No
                                        </Form.Label>
                                        <Col sm={6}>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="text"
                                                name="ticket_no"
                                                value={formData?.ticket_no}
                                                onChange={handleChange}
                                                placeholder="Tickets No"
                                                className="input-mandatory"
                                                id="inputticket_no"
                                                disabled
                                              />{" "}
                                              <span className="error-message"></span>
                                            </InputGroup>
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="main-form-section mt-5">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={3}>
                                          Subject
                                        </Form.Label>
                                        <Col sm={6}>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="text"
                                                name="subject"
                                                value={formData?.subject?.name}
                                                onChange={handleChange}
                                                placeholder="Tickets No"
                                                className="input-mandatory"
                                                id="inputsubject"
                                                disabled
                                              />{" "}
                                              <span className="error-message"></span>
                                            </InputGroup>
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>
                                  <Col md={12}>
                                    <div className="main-form-section mt-5">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={3}>
                                          Title
                                        </Form.Label>
                                        <Col sm={6}>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="text"
                                                name="title"
                                                value={formData?.title}
                                                onChange={handleChange}
                                                placeholder="title"
                                                className="input-mandatory"
                                                id="inputtitle"
                                                disabled
                                              />{" "}
                                              <span className="error-message"></span>
                                            </InputGroup>
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>
                                  <Col md={12}>
                                    <div className="main-form-section mt-5">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={3}>
                                          Description
                                        </Form.Label>
                                        <Col sm={6}>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                as="textarea"
                                                name="description"
                                                value={formData?.description}
                                                onChange={handleChange}
                                                placeholder="description"
                                                className="input-mandatory"
                                                id="inputdescription"
                                                disabled
                                              />{" "}
                                              <span className="error-message"></span>
                                            </InputGroup>
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>{" "}
                                  {formData?.image && (
                                    <Col md={12}>
                                      <div className="main-form-section mt-5">
                                        <div className="text-center mb-4">
                                          <img
                                            src={IMG_URL + formData?.image}
                                            alt="Screenshot"
                                            style={{
                                              width: "40%",
                                              maxHeight: "50vh",
                                              objectFit: "contain",
                                              borderRadius: "8px",
                                              boxShadow:
                                                "0 0 10px rgba(0,0,0,0.2)",
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </Col>
                                  )}
                                  <Col md={12}>
                                    <div className="main-form-section mt-5">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={3}>
                                          Ticket Status
                                        </Form.Label>

                                        <Col sm={6}>
                                          <Select
                                            name="ticket_status_id"
                                            id="inputticket_status_id"
                                            className="input-mandatory"
                                            placeholder="Ticket Status"
                                            required={true}
                                            options={ticket_status}
                                            value={formData.ticket_status_id}
                                            onChange={(selectedOption) =>
                                              handleChange(selectedOption)
                                            }
                                            // isDisabled={
                                            //   !(
                                            //     IDS.TicketStatus.Requested ===
                                            //       formData?.ticket_status_id
                                            //         ?.value ||
                                            //     IDS.TicketStatus.Processing ===
                                            //       formData?.ticket_status_id
                                            //         ?.value
                                            //   )
                                            // }
                                          />
                                          <span className="error-message"></span>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>
                                  <Col md={12}>
                                    <div className="main-form-section mt-5">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={3}>
                                          Remarks
                                        </Form.Label>

                                        <Col sm={6}>
                                          <Form.Group>
                                            <Form.Control
                                              as="textarea"
                                              rows={4}
                                              name="remarks"
                                              value={formData?.remarks || ""}
                                              onChange={handleChange}
                                              placeholder="Remarks"
                                              className="input-mandatory"
                                              id="inputremarks"
                                              // disabled={
                                              //   !(
                                              //     IDS.TicketStatus.Requested ===
                                              //       formData?.ticket_status_id
                                              //         ?.value ||
                                              //     IDS.TicketStatus
                                              //       .Processing ===
                                              //       formData?.ticket_status_id
                                              //         ?.value
                                              //   )
                                              // }
                                            />

                                            <span className="error-message"></span>
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>
                                </Row>

                                <Row className="mt-5 pb-3">
                                  <div className="d-flex justify-content-center">
                                    <Link>
                                      <CancelButton
                                        name={"cancel"}
                                        handleClose={props.handleClose}
                                      />
                                    </Link>

                                    <SaveButton
                                      name={"save"}
                                      handleSubmit={handleSubmit}
                                    />
                                  </div>
                                </Row>
                              </Col>
                            </Row>
                          </Form>
                        </Col>
                      </Row>
                    </Container>
                  </Col>
                </Row>
              </Container>
            </Card.Body>
          </Card>
        </Offcanvas.Body>
      </Offcanvas>
      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};
export default EditOffCanvance;
